import { useNavigate, useParams } from "react-router-dom";
import {UseHubName} from "../Hooks/UseHubName";
import { useUserPermissions } from "../Hooks/GetUserPermissions";

const LobbyGestion = () => {
  const navigate = useNavigate();
  const { hubId } = useParams();
  const hubName = UseHubName(hubId);
  const { permisos, loading } = useUserPermissions();

  if (loading) return <p>Cargando...</p>;
  if (!permisos) return <p>No tienes permisos para acceder.</p>;

  return (
    <div className="lobby-gestion-container">
      {/* Header */}
      <div className="header-container">
        <header className="header">
          <h1 className="header-title">Menú de {hubName}</h1>
          <div className="logout-button-container">
            <button onClick={() => navigate(-1)} className="logout-button">
              ← Volver
            </button>
          </div>
        </header>
      </div>

      <div
        className="data-box"
        style={{
          alignContent: "center",
          display: "flex",
          justifyContent: "center",
        }}
      >
        {permisos.verCalendario && permisos.verCalendario.includes('lectura') && (
          <button
            className="seccion-btn"
            onClick={() => navigate(`calendario`)}
            style={{ margin: "20px" }}
          >
            Personal
          </button>
        )}
        {permisos.verCompras && permisos.verCompras.includes('lectura') && (
          <button
            className="seccion-btn"
            onClick={() => navigate(`historialCompras`)}
            style={{ margin: "20px" }}
          >
            Compras
          </button>
        )}
      </div>
    </div>
  );
};

export default LobbyGestion;
